import React from "react";
import { useNavigate } from "react-router-dom";
import { PeekChip, PeekListItem, PeekListItemButton, PeekListItemIcon, PeekListItemText, useTheme, } from "@piiqtechnologies/ui-components";
import { useAnalytics } from "@piiqtechnologies/ui-lib";
import { PATHS } from "@constants/Paths";
export const NavigationCommunityItem = ({ community }) => {
    var _a;
    const theme = useTheme();
    const analytics = useAnalytics();
    const navigate = useNavigate();
    const handleCommunityClick = () => {
        analytics.track("Time Series");
        navigate(`${PATHS.COMMUNITY.replace(":communityId", community.id)}`);
    };
    return (React.createElement(PeekListItem, null,
        React.createElement(PeekListItemButton, { onClick: handleCommunityClick, sx: {
                backgroundColor: theme.palette.teal[100],
                borderRadius: 1,
                minHeight: theme.spacing(3.6),
                ml: 0,
                p: 0,
            } },
            React.createElement(PeekListItemIcon, null,
                React.createElement(PeekChip, { size: "small", variant: "filled", color: "primary", label: (_a = community === null || community === void 0 ? void 0 : community.label) === null || _a === void 0 ? void 0 : _a[0], sx: {
                        ml: -0.5,
                        mr: 0.5,
                        ".MuiChip-label": {
                            px: 0.5,
                            fontSize: "10px",
                            lineHeight: "7px",
                        },
                    } })),
            React.createElement(PeekListItemText, { primary: community === null || community === void 0 ? void 0 : community.label, primaryTypographyProps: {
                    variant: "h4",
                    fontWeight: theme.typography.fontWeightMedium,
                } }))));
};
export default NavigationCommunityItem;
